import React from 'react';
import { useWebSocketEvents } from '@/shared/hooks/useWebSocketEvents';

/**
 * Componente que inicializa los listeners globales de WebSocket
 * Se monta una sola vez en la aplicación y maneja todos los eventos
 */
const WebSocketInitializer: React.FC = () => {
  // Inicializar los listeners globales de WebSocket
  useWebSocketEvents();

  // Este componente no renderiza nada, solo inicializa los listeners
  return null;
};

export default WebSocketInitializer;
